import { render, staticRenderFns } from "./ShortcutDashboard.vue?vue&type=template&id=098e8e5e&scoped=true&"
import script from "./ShortcutDashboard.vue?vue&type=script&lang=js&"
export * from "./ShortcutDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ShortcutDashboard.vue?vue&type=style&index=0&id=098e8e5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098e8e5e",
  null
  
)

export default component.exports